// images @ ui/src/components/static/
// files @ ui/public/

import React, { Component } from 'react'
import './home.css'

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
//console.log('images:', images)


class HomeEN extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    //console.log('images: ', images)
    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >
        <p id="FSV Usage" className="line-spacing" style={{fontSize: "24px", color: 'red', textAlign: 'center'}}>五星词汇搭建法</p>
        <p className="line-spacing" style={{textAlign: 'center'}}> <b>理解更深刻，记忆更持久，回忆更轻松</b></p>
        <hr style={{   background: 'lime',   color: 'lime',   borderColor: 'lime',   height: '1px', }}       />
        <p style={{ color: 'blue' }}> FiveStar Vocabulary Builder（五星词汇搭建法）与 SpellingBee（拼字比赛）是两款功能互补的拼字游戏，旨在帮助您掌握<b>深度词汇</b>。 FiveStar Vocabulary Builder 通过在图像、五个组成部分和单词之间建立联系来加深您的理解，而SpellingBee则专注于听力理解与单词拼写。</p>
        <br></br>


        <p id="FSV ref" className="title is-6">1. 人工智能时代的深度与浅层词汇</p> 
        <p>"深度词汇：AI 让这项技能更有价值，而非过时" — Cal Newport</p>
        <img src={images['Cal-Newport-small.png']} width="459" height="222" alt="Cal Newport" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p>演示视频以类比方式展示了两种词汇学习的不同结果 (source: 长沙一家人"捡瓶子比赛")</p>
        <br></br>
        <video width="263" height="394" controls >
        <source src="./videos/bottle-collect-demo-1min.mp4" type="video/mp4"/>
        </video>
        <br></br> <br></br>

        <p><b>2. FiveStar Vocab [1] </b>是一种用于掌握英语深度词汇的方法。为了实现易于深层次的理解，每个单词都被拆解为五个核心组成部分，这为 ESL 学习者提供了一条“最小阻力”的学习路径 。</p>
        <br></br>
        <p>The featured COEI segment (Characteristics or Essential Information) helps learners achieve deep comprehension. By creating a 'scaffolded' retrieval path [2], it empowers students—particularly ESL learners and beginners—to successfully recall words even after long intervals.</p>
        <img src={images['five-star-word-w-5com.png']} width="285" height="196" alt="five-star-figure" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p id="FSV ref" className="title is-6">3. The Learning Resources for the FiveStar Vocabulary Builder</p>
        <p>1. Video links: </p>
        <p>
          <a href="https://www.youtube.com/@FiveStarVocab" target="_blank" rel="noopener noreferrer"> <u>https://www.youtube.com/@FiveStarVocab</u>
          </a>
        </p>
        <p>
          <a href="https://space.bilibili.com/3546872866146315" target="_blank" rel="noopener noreferrer"> <u>https://space.bilibili.com/3546872866146315  (中国大陆)</u>
          </a>
        </p>

        {/* <p> not available in Mainland China
          <a href="https://www.bilibili.tv/en/space/1430633718 " target="_blank" rel="noopener noreferrer"> <u>https://www.bilibili.tv/en/space/1430633718 (South Asia)</u>
          </a>
        </p> */}
        <br></br>

        <p>2. Free booklet download:
          <a href="./books/book2.pdf" target="_blank" rel="noopener noreferrer"> <u>"FiveStar Vocabulary Builder – Mobile Edition"</u>
          </a>        
        </p>
        <p>To check the publish and upcoming books, please tap here   
          <a href="./books.txt" target="_blank"><u> books</u></a>
        </p>
        <br></br>

        <p>3. Customized Services and Contacts</p>
        <p>If you have a specialized vocabulary list or any other language you wish to adapt into the FiveStar Vocab
        style book, or you would like to order the upcoming books, please click "Email Contact" at the bottom of this page.</p>
        <br></br>

        <p id="FSV ref" className="title is-6">4. Key References</p> 
        <p>[1] 
        <a href="./books/book2.pdf" target="_blank" rel="noopener noreferrer"> <u>FiveStar Vocabulary Builder – Mobile Edition</u>
          </a>
        </p>
        <p>[2] Lev Vygotsky, Zone of Proximal Development (ZPD) and Scaffolding, 1930s</p>
        <p>[3] Nation, I. S. P., Learning Vocabulary in Another Language, Cambridge University Press, 2013</p>
        <p>[4] Bjork, E. L., & Bjork, R. A., Introducing desirable difficulties into practice and instruction: Obstacles and opportunities, 2023
        </p>
        <br></br>

      </section>
    )
  }
}

export default HomeEN